(function () {
  'use strict';

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  ready(function () {
    document.querySelectorAll('[data-site-header]').forEach(function (header) {
      const toggle = header.querySelector('[data-mobile-menu-toggle]');
      const nav = header.querySelector('[data-mobile-nav]');
      const backdrop = header.querySelector('[data-mobile-menu-backdrop]');
      const dropdownTriggers = header.querySelectorAll('[data-mobile-dropdown-trigger]');

      function setDrawerTop() {
        if (!nav) return;
        nav.style.setProperty('--mobile-drawer-top', header.offsetHeight + 'px');
      }

      function openMenu() {
        if (!toggle || !nav) return;
        header.classList.add('is-menu-open');
        toggle.classList.add('is-active');
        nav.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('mobile-menu-lock');
        document.body.classList.add('mobile-menu-lock');
        setDrawerTop();
      }

      function closeMenu() {
        if (!toggle || !nav) return;
        header.classList.remove('is-menu-open');
        toggle.classList.remove('is-active');
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('mobile-menu-lock');
        document.body.classList.remove('mobile-menu-lock');
      }

      if (toggle && nav) {
        setDrawerTop();
        window.addEventListener('resize', setDrawerTop);

        toggle.addEventListener('click', function () {
          nav.classList.contains('is-open') ? closeMenu() : openMenu();
        });
      }

      if (backdrop) {
        backdrop.addEventListener('click', closeMenu);
      }

      dropdownTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
          if (window.innerWidth > 920) return;
          event.preventDefault();
          const item = trigger.closest('.nav-item');
          if (item) item.classList.toggle('is-open');
        });
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeMenu();
      });
    });

    document.querySelectorAll('[data-copy-link]').forEach(function (button) {
      button.addEventListener('click', function () {
        const url = button.dataset.shareUrl || window.location.href;
        const message = document.querySelector('[data-share-message]');

        if (navigator.share) {
          navigator.share({ title: document.title, url: url }).catch(function () {});
          return;
        }

        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            if (!message) return;
            message.hidden = false;
            setTimeout(function () { message.hidden = true; }, 2200);
          });
        }
      });
    });
  });
})();
